<!-- <footer id="footer">
    <section class="inner">
        <div class="bottom-footer">
            <ul class="policy-links">
                <li><a href="term-condition.html" title="TERMS &amp; CONDITIONS">TERMS &amp; CONDITIONS</a>
                </li>
                <li><a href="faq.html" title="FAQ">FAQ</a>
                </li>
            </ul>
            <p class="copy-right">&copy; 2017 Malayan Banking Berhad (Company No, 3813-K). All rights reserved.</p>
        </div>
    </section>
</footer> -->

<footer class="footer-social-icon text-center section_padding_20 clearfix">
    <!-- footer logo -->
    <!-- <div class="footer-text">
        <h2>Ca.</h2>
    </div> -->
    <!-- social icon-->
    <div class="footer-social-icon">
        <a href="https://www.facebook.com/Maybank/" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
        <a href="https://twitter.com/MyMaybank" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
        <a href="https://www.instagram.com/mymaybank/" target="_blank"> <i class="fa fa-instagram" aria-hidden="true"></i></a>
    </div>
    <div class="footer-menu">
        <nav>
            <ul>
                <li><a href="assets/tnc.pdf">Terms &amp; Conditions</a></li>
                <li><a href="assets/pnc.pdf">Privacy Policy</a></li>
                <li><a href="assets/faq/index.html">FAQ</a></li>
            </ul>
        </nav>
    </div>
    <!-- Foooter Text-->
    <div class="copyright-text">
        <!-- ***** Removing this text is now allowed! This template is licensed under CC BY 3.0 ***** -->
        <p>© {{year}}, Malayan Banking Berhad (Company No 3813-K). All Rights Reserved.</p>
    </div>
</footer>